import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCartItems,
  selectUnitToken,
  setCartItems,
} from '@homeplay/app';
import { apiGetCart, apiSaveCart } from '@homeplay/api';
import { markExpiredCartItems } from '../utils/cartHelpers';

export const useCartSync = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector(selectCartItems);
  const unitToken = useSelector(selectUnitToken);

  const isHydrating = useRef(false);
  const hasHydrated = useRef(false);
  const isFirstSyncRender = useRef(true);

  useEffect(() => {
    if (hasHydrated.current || cartItems.length > 0 || !unitToken) return;

    hasHydrated.current = true;
    isHydrating.current = true;

    apiGetCart({ unitToken })
      .then((data) => {
        const cart = data?.cart;
        if (!cart || cart.length === 0) return;
        const marked = markExpiredCartItems(cart);
        if (marked.length > 0) dispatch(setCartItems(marked));
      })
      .catch((error) => {
        console.error('useCartSync: hydration failed', error);
      })
      .finally(() => {
        Promise.resolve().then(() => {
          isHydrating.current = false;
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitToken]);

  useEffect(() => {
    if (isFirstSyncRender.current) {
      isFirstSyncRender.current = false;
      return;
    }
    if (isHydrating.current || !unitToken || cartItems.length === 0) return;

    apiSaveCart({ unitToken, cart: cartItems }).catch((error) => {
      console.error('useCartSync: save failed', error);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);
};
